import { useEffect, useState } from 'react';
import axios from 'axios';

import { Search16w } from '../../../images/icons/icons_component';

const Emog_popup = ({ onClose, onSelect }) => {

    const [locaList, setLocaList] = useState([]);
    const [hospList, setHospList] = useState([]);
    const [searchParams, setSearchParams] = useState({
        searchEmog: '',
        searchLoca: '',
        searchGrdc: '',
    });

    const activeEnter = (e) => {
        if (e.key === 'Enter') {
            fetchHospList();
        }
    };

    useEffect(() => {
        const fetchInitialData = async () => {
            try {
                const response = await axios.get('/commonapi/member/locaList.do');
                setLocaList(response.data.locaList || []);
            } catch (error) {
                console.error('초기 데이터 로딩 중 오류 발생:', error);
            }
        };
        fetchInitialData();
    }, []);

    const fetchHospList = async () => {
        try {
            const response = await axios.get('/commonapi/member/emogList.do', {
                params: {
                    emog: searchParams.searchEmog,
                    loca: searchParams.searchLoca,
                },
            });
            setHospList(response.data.emogList);
        } catch (error) {
            console.error('병원 목록 로딩 중 오류 발생:', error);
        }
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setSearchParams((prev) => ({
            ...prev,
            [name]: value,
        }));
    };
    
    const selectEmog = (hosp) => {
        if (window.confirm(`${hosp.EMOGDESC}으로 소속기관을 선택하시겠습니까?`)) {
            onSelect?.({
                emogcode: hosp.EMOGCODE,
                emogdesc: hosp.EMOGDESC,
                authcode: hosp.AUTHCODE,
            });
            onClose();
        }
    };
    
    // esc 키 누르면 모달 닫히는 기능
    useEffect(() => {
        const handleEscape = (e) => {
            if (e.key === 'Escape') onClose();
        };

        // 이벤트 리스너 등록
        document.addEventListener('keydown', handleEscape);

        // 컴포넌트가 언마운트될 때 이벤트 리스너 제거
        return () => {
            document.removeEventListener('keydown', handleEscape);
        };
    }, [onClose]);

    return (
        <div className='modal_container'>
            <div className='emog_wrapper'>
                <div className='flex flex-col gap-5 items-center'>
                    <h4>기관 검색</h4>
                    <hr className='w-full'/>
                    <div className='flex gap-2'>
                        <select
                            name='searchLoca'
                            className='w-32'
                            value={searchParams.searchLoca}
                            onChange={handleInputChange}
                        >
                            <option value=''>전체</option>
                            {locaList.map((loca) => (
                                <option key={loca.bscdminr} value={loca.bscdminr}>
                                    {loca.bscddesc}
                                </option>
                            ))}
                        </select>
                        <input
                            type='text'
                            name='searchEmog'
                            value={searchParams.searchEmog}
                            onKeyDown={activeEnter}
                            onChange={handleInputChange}
                            placeholder='기관명'
                            aria-label='기관명'
                        />
                        <button className='search_btn bg_co_black w-24' onClick={fetchHospList}><Search16w />검색</button>
                    </div>
                    <div className='data_grid_container w-full'>
                        <hr className='border-t-2 co_border_black mr-1-1'/>
                        <div>
                            <div className='emog_section' style={{ maxHeight: '8rem' }}>
                                <table>
                                    <colgroup>
                                        <col width='35%' />
                                        <col width='65%' />
                                    </colgroup>
                                    <thead>
                                        <tr>
                                            <th>기관명</th>
                                            <th>주소</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {hospList && hospList.length > 0 ? (
                                            hospList.map((hosp, idx) => (
                                                <tr
                                                    key={idx}
                                                    className='cursor-pointer bg_co_odd_h'
                                                    onClick={() => selectEmog(hosp)}
                                                >
                                                    <td><button className='underline'>{hosp.EMOGDESC}</button></td>
                                                    <td>{hosp.ADDRROAD}</td>
                                                </tr>
                                            ))
                                        ) : (
                                            <tr>
                                                <td colSpan='2'>
                                                    <div className='co_gray p-5'>
                                                        기관을 검색해주세요.
                                                    </div>
                                                </td>
                                            </tr>
                                        )}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                        <hr className='co_border_gray mr-1-1'></hr>
                    </div>
                    <hr className='w-full'/>
                    <button className='modal_btn w-full bg_co_black cursor-pointer' onClick={onClose}>닫기</button>
                </div>
            </div>
        </div>
    );
};
export default Emog_popup;